<template>
  <div class="config-user-machine">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="1140px"
      top="6vh"
      custom-class="config-dialog"
      @open="handleOpen"
      @closed="handleClosed"
    >
      <div v-loading="loading" :element-loading-text="$t('common.request')">
        <el-form
          ref="configForm"
          :model="formData"
          :rules="formRules"
          label-position="top"
          label-width="80px"
        >
          <!-- 开门柜设置 -->
          <OpenDoorSettings
            v-model="formData.openDoor"
            :yes-no="yesNo"
          />

          <!-- 管理员设置 -->
          <ManagerSettings
            :config="formData.manager"
            :yes-no="yesNo"
          />
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel" size="small">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          :loading="loading"
          @click="handleSubmit"
        >
          {{ $t('common.definite') }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 年龄识别扣费提示弹窗 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('user.ConfigUserMachine.879870-0')"
      :visible.sync="ageCostDialogVisible"
      width="300px"
      :close-on-click-modal="false"
      center
    >
      <span>{{ $t('user.ConfigUserMachine.879870-1') }}</span>
      <span style="color: red">${{ walletPrice }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleRecharge">
          {{ $t('user.ConfigUserMachine.879870-2') }}
        </el-button>
        <el-button
          v-if="walletPrice >= 1"
          size="small"
          type="primary"
          @click="handleContinueAge"
        >
          {{ $t('user.ConfigUserMachine.879870-3') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OpenDoorSettings from './config/OpenDoorSettings.vue';
import ManagerSettings from './config/ManagerSettings.vue';

export default {
  name: 'ConfigUserMachine',
  components: {
    OpenDoorSettings,
    ManagerSettings
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userEquipment: {
      type: Object,
      default: () => ({})
    },
    yesNo: {
      type: Array,
      default: () => []
    },
    ageDevice: {
      type: Array,
      default: () => []
    },
    feelLock: {
      type: Array,
      default: () => []
    },
    ageType: {
      type: Array,
      default: () => []
    },
    priorityMode: {
      type: Array,
      default: () => []
    },
    deviceMode: {
      type: Array,
      default: () => []
    },
    biaoshi: {
      type: Boolean,
      default: false
    },
    IdcardCountry: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        info: {},
        age: { time: [] },
        manager: {},
        model: { time: [] },
        remote: {},
        shopping: {},
        vatRate: {},
        openDoor: {
          detectType: null,
          cameraSelect: null,
          pendOrderAlarmSwitch: 0,
          pendOrderAlarmNum: null,
          pendOrderAlarmDisableMachine: null,
          orderTimeoutWarnSwitch: 0,
          orderTimeoutWarnTime: null,
          longTimeSettleOrderSwitch: 0,
          closeTimeSet: null,
          orderTimeoutChargeSwitch: 0,
          orderTimeoutSet: null,
          realDisplayPickUpSwitch: 0,
          preAuthAmount: null
        },
        advert: {}
      },
      formRules: {},
      // 年龄识别扣费
      ageCostDialogVisible: false,
      walletPrice: 0
    };
  },
  computed: {
    ...mapGetters(['token']),
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
        if (!val) {
          this.$emit('cancel', false);
        }
      }
    },
    dialogTitle() {
      return this.biaoshi
        ? this.$t('machineConfig.plConfig')
        : this.$t('machineUser.mConfig');
    }
  },
  methods: {
    handleOpen() {
      this.initFormData();
    },
    handleClosed() {
      this.resetForm();
    },
    initFormData() {
      if (this.userEquipment && this.userEquipment.config) {
        const config = JSON.parse(JSON.stringify(this.userEquipment.config));
        const openDoorSource = this.userEquipment.userEquipmentOpenDoorDTO || {};
        const normalizedOpenDoorSource = {
          ...openDoorSource,
          realDisplayPickUpSwitch:
            openDoorSource.realDisplayPickUpSwitch ?? openDoorSource.realDisplayPickupSwitch
        };
        
        // 使用 Vue.set 方式更新 formData 的各个属性，保持响应式
        Object.keys(config).forEach(key => {
          this.$set(this.formData, key, config[key]);
        });
        
        // 确保 openDoor 对象存在且有默认值
        if (!this.formData.openDoor) {
          this.$set(this.formData, 'openDoor', {});
        }
        
        // 为所有 openDoor 字段设置默认值
        const openDoorDefaults = {
          detectType: null,
          cameraSelect: null,
          pendOrderAlarmSwitch: 0,
          pendOrderAlarmNum: null,
          pendOrderAlarmDisableMachine: null,
          orderTimeoutWarnSwitch: 0,
          orderTimeoutWarnTime: null,
          longTimeSettleOrderSwitch: 0,
          closeTimeSet: null,
          orderTimeoutChargeSwitch: 0,
          orderTimeoutSet: null,
          realDisplayPickUpSwitch: 0,
          preAuthAmount: null
        };
        
        // 使用 $set 更新 openDoor 对象，保持响应式
        this.$set(this.formData, 'openDoor', {
          ...openDoorDefaults,
          ...this.formData.openDoor,
          ...normalizedOpenDoorSource
        });
        
        // 初始化时间数组
        if (!this.formData.age?.time?.length) {
          this.$set(this.formData, 'age', this.formData.age || {});
          this.$set(this.formData.age, 'time', this.generateTimeSlots());
        }
        if (!this.formData.model?.time?.length) {
          this.$set(this.formData, 'model', this.formData.model || {});
          this.$set(this.formData.model, 'time', this.generateTimeSlots());
        }
        
        // 钱包余额
        this.walletPrice = this.userEquipment.walletPrice || 0;
      }
    },
    generateTimeSlots() {
      const slots = [];
      for (let i = 0; i < 336; i++) {
        const week = Math.floor(i / 48) + 1;
        const slotInDay = i % 48;
        const hour = Math.floor(slotInDay / 2);
        const startMinute = (slotInDay % 2) * 30;
        const endMinute = startMinute + 29;
        slots.push({
          start: `${String(hour).padStart(2, '0')}:${String(startMinute).padStart(2, '0')}:00`,
          end: `${String(hour).padStart(2, '0')}:${String(endMinute).padStart(2, '0')}:59`,
          week
        });
      }
      return slots;
    },
    resetForm() {
      this.$refs.configForm?.clearValidate();
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleSubmit() {
      this.$refs.configForm.validate(valid => {
        if (!valid) return;

        const submitData = JSON.parse(JSON.stringify(this.userEquipment));
        submitData.config = JSON.parse(JSON.stringify(this.formData));

        // 清理全选的时间段
        if (submitData.config.age?.time?.length >= 336) {
          submitData.config.age.time = [];
        }
        if (submitData.config.model?.time?.length >= 336) {
          submitData.config.model.time = [];
        }

        const url = this.biaoshi
          ? this.$url.UserMachine.gmodify
          : this.$url.UserMachine.modify;

        this.loading = true;
        this.$api
          .request(url, this.$method.put, submitData)
          .then(res => {
            if (res.code === 0) {
              this.$notify({
                title: this.$t('common.tip'),
                message: this.$t('editUserMachine.up'),
                type: 'success'
              });
              this.$emit('cancel', false, 'update');
            }
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
      });
    },
    handlePrivacyUpdate(content) {
      this.formData.info.privacy = content;
    },
    handleRecharge() {
      this.$router.push('/mywallet/topup');
    },
    handleContinueAge() {
      this.formData.age.isAge = 1;
      this.ageCostDialogVisible = false;
    }
  }
};
</script>

<style lang="scss">
.config-dialog {
  border-radius: 6px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;

  .el-dialog__header {
    padding: 15px 15px 15px 20px;
    background-color: #409eff;
    border-radius: 5px 5px 0 0;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: white;
  }

  .el-dialog__title {
    color: white;
  }

  .el-dialog__body {
    height: 600px;
    overflow-y: auto;
    padding: 20px 10px 0 20px;
  }

  .el-dialog__footer {
    padding: 20px;
  }

  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  .el-form-item {
    margin: 0;
  }

  .el-form > :first-child .config-section-title {
    margin-top: 0;
  }

  .el-dialog__headerbtn {
    top: 20px;
    right: 15px;
  }
}
</style>
